<template>
  <div class="">
    <div class="" v-if="Object.keys(sidebarData).length > 0">
      <m-a v-if="this.findAnswer().length > 0"
           class="btn btn-primary px-5 rounded-pill form-answer-1-result-button"
           :href="this.findAnswer()" v-t="`form.form_answer.show_result_button`">

      </m-a>
    </div>
  </div>
</template>

<script>
import TransactionInfo from "../../ShoppingCart/FactorGeneralInfo/TransactionInfo/TransactionInfo1.vue";
import mA from "../../Tags/A.vue";
import mGateManager1 from "../../Gate/GateManager/GateManager1.vue";
import {mapGetters} from "vuex";
import {productName} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Product";
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {dateConverter, formatNumber} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter";

export default {
  name: "FormAnswer1",
  components: {TransactionInfo, mA, mGateManager1},
  props: {
    answerPages: {
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      items: "ShoppingCart/getUserOrderPaidItems",
      transactionInfo: "Transaction/getTransaction",
      sidebarData: "Transaction/getFactor",
      loading: "Loading/loadingStatus"
    }),
    pageTitle() {
      return (this.sidebarData.transaction != null || (this.sidebarData.loan_transaction != null && this.sidebarData.loan_transaction.length != 0)) ? this.$t('factor.factor') : this.$t('factor.pre_factor')
    },

  },
  data() {
    return {
      selectedGate: '',
      payButtonStatus: false
    }
  },
  methods: {
    productName,
    findAttributeOnSiteInfo,
    printPage() {
      const printMode2 = document.querySelectorAll('.print-mode-2')

      printMode2.forEach(item => {
        item.classList.remove('d-print-none')
      })

      window.print();
    },
    formatNumber,
    dateConverter,
    async submit() {
      this.payButtonStatus = true
      let order = this.sidebarData.id
      let gate = this.selectedGate

      let createTransaction = await this.$store.dispatch('Transaction/createTransaction', {
        order,
        gate
      })


    },
    setFactorData(req) {
      req.then(async (res) => {
        const response = await res.data.data;
        await this.$store.commit("ShoppingCart/setSidebarBasketData", response);
        await this.$store.commit("Transaction/setFactor", response);
        await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
        await this.$store.commit("ShoppingCart/setUserOrderPaidItems", response.items);
        if (response.transaction == undefined) {
          await this.$store.commit("Transaction/setTransaction", response.loan_transaction);
        } else {
          await this.$store.commit("Transaction/setTransaction", response.transaction);
        }
      })
    },
    getBaseVariables(items) {
      let result = {}

      for (const key in items) {
        if (items.hasOwnProperty(key)) {
          const item = items[key];

          if (!result.hasOwnProperty(item.group)) {
            result[item.group] = 0
          }

          result[item.group] += parseInt(item.value)
        }
      }
      return result
    },
    calculateResultBaseOnVariables(items) {
      let result = ''
      let variables = this.getBaseVariables(items)
      let warm = variables['warm']
      let cold = variables['cold']
      let wet = variables['wet']
      let dry = variables['dry']
      let threshold = 5

      let warmColdMezaj = warm - cold
      let wetDryMezaj = wet - dry
      let warmColdMezajResult = ''
      let wetDryMezajResult = ''


      if (warmColdMezaj > threshold) {
        warmColdMezajResult = 'warm'
      }

      if (warmColdMezaj < threshold) {
        warmColdMezajResult = 'cold'
      }

      if (wetDryMezaj > threshold) {
        wetDryMezajResult = 'dry'
      }

      if (wetDryMezaj <= threshold) {
        wetDryMezajResult = 'wet'
      }

      if (warmColdMezajResult == 'warm' && wetDryMezajResult == 'wet') {
        result = 'damavi'
      }

      if (warmColdMezajResult == 'warm' && wetDryMezajResult == 'dry') {
        result = 'safravi'
      }

      if (warmColdMezajResult == 'cold' && wetDryMezajResult == 'wet') {
        result = 'balghami'
      }

      if (warmColdMezajResult == 'cold' && wetDryMezajResult == 'dry') {
        result = 'sovdavi'
      }

      if (((warmColdMezaj > 0) && (warmColdMezaj <= threshold)) && ((wetDryMezajResult > 0) && (wetDryMezajResult <= threshold))) {
        result = 'etedal'
      }

      return result
    },
    answerLink(result) {
      let answerJson = JSON.parse(this.answerPages)
      let link = ''
      answerJson.find(item => {
        if (item.answer == result) {
          link = item.page
        }
      })
      return link
    },
    findAnswer() {
      // group base on answers
      let items = JSON.parse(this.sidebarData.description);
      let result = this.calculateResultBaseOnVariables(items)

      return this.answerLink(result)
    }
  },
  async mounted() {

    let orderId;
    let req;

    let pageName = this.$route.name;


    /*
    *
    *
    * NOTE
    *  MAKE ONE OF THE CONDITION BELOW `TRUE`
    *
    *
    *
    * */


    if (pageName == 'FactorWithSlug') {
      orderId = process.env.NODE_ENV != 'development' ? this.$route.params.slug : '2v6i1r6h7u7n'
      req = this.$store.dispatch('Transaction/showOrderDetail', orderId)
    }
    if (pageName == 'Factor') {
      orderId = process.env.NODE_ENV != 'development' ? this.$route.params.orderId : 5
      req = this.$store.dispatch('Transaction/autoPrintShowTransactionDetail', orderId)
    }
    if (pageName == 'verifyTransaction') {
      const slug = process.env.NODE_ENV != 'development' ? this.$route.params.slug : '2v6i1r6h7u7n'
      req = this.$store.dispatch("Transaction/verifyTransactionWithoutState", slug)
    }

    this.setFactorData(req)

  },
  watch: {
    loading(newValue, oldValue) {
      if (oldValue == true) {
        // add time out to make some time for loadign hide in page.
        setTimeout(() => {
          if (this.$route.query.print === 'on') {
            this.printPage()
          }
        }, 1_000)
      }
    }
  }
}
</script>

<style scoped>

</style>